import { EmailDeliveryStateEnum } from '../../../generated/internal.graphql';

/**
 * The lifecycle of one email send, keyed off the generated `EmailDeliveryStateEnum` so a backend
 * rename is a compile error here rather than a silently dead comparison at a call site.
 *
 * Unlike `Internal/Order/OrderState`, there is no `to…State` narrowing helper to add: the schema
 * types `EmailDelivery.state` as the enum itself, not as a bare `String!`, so the generated field is
 * already this union and a cast would only launder it.
 *
 * The keys here are upper-cased for the call site; the **wire values are lowercase** (`pending`,
 * `sent`, `delivered`, `failed`), unlike `EmailDeliveryGroupBy`'s SCREAMING_CASE ones. That matters
 * the moment a state filter round-trips through a URL query parameter — compare against these
 * members, never against a hand-written literal.
 */
export const EmailDeliveryState = Object.freeze({
  PENDING: EmailDeliveryStateEnum.Pending,
  SENT: EmailDeliveryStateEnum.Sent,
  DELIVERED: EmailDeliveryStateEnum.Delivered,
  FAILED: EmailDeliveryStateEnum.Failed,
});
export type EmailDeliveryState = (typeof EmailDeliveryState)[keyof typeof EmailDeliveryState];
